import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { getFullDate } from "helpers/Function";
import { useIntl } from "react-intl";

const ServiceShowApplication = ({ match }) => {
	const {
		params: { applicationID },
	} = match;
	const { locale } = useIntl();

	const [data, setData] = useState("");
	const [services, setServices] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تفاصيل طلب الخدمة",
				breadcrumb: "الخدمات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/ServiceOrder/${applicationID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
				let servicesArray = [];
				// eslint-disable-next-line array-callback-return
				response.data.data.services.map(service => {
					servicesArray.push(service.data.title);
				});
				setServices(servicesArray);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row order-app">
				<div className="col-md-12">
					<div className="row">
						<div className="col-md-12">
							<div className="form-item">
								<label htmlFor="services">الخدمات المطلوبة</label>
								{/* <input
									type="text"
									id="services"
									defaultValue={services.join(" - ")}
									readOnly
								/> */}
								<p className="order-desc">{services.join("  --  ")}</p>
							</div>
						</div>
						{/* <div className="col-md-4">
							<div className="form-item">
								<label htmlFor="coast">التكلفة</label>
								<input
									type="text"
									id="coast"
									defaultValue={
										loading
											? ""
											: `${data.cost.cost_range.from} - ${data.cost.cost_range.to}`
									}
								/>
							</div>
						</div>
						<div className="col-md-4">
							<div className="form-item">
								<label htmlFor="coast">المدة المطلوبة</label>
								<input type="text" id="duration" defaultValue={data.duration} />
							</div>
						</div> */}
					</div>
					{/* <div className="form-item">
						<label htmlFor="title">اسم المشروع</label>
						<input type="text" id="title" defaultValue={data.title} />
					</div>
					<div className="form-item">
						<label htmlFor="about">وصف المشروع</label>
						<textarea id="about" defaultValue={data.about}></textarea>
					</div>
					<div className="form-item">
						<label htmlFor="examples">أمثلة</label>
						<textarea id="examples" defaultValue={data.examples}></textarea>
					</div> */}
					<div className="row">
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="name">اسم العميل</label>
								<p className="order-desc">{data.name}</p>
								{/* <input type="text" id="name" defaultValue={data.name} /> */}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="name">تاريخ الطلب</label>
								<p className="order-desc">
									{getFullDate(data.created_at, locale)}
								</p>
								{/* <input type="text" id="name" defaultValue={data.name} /> */}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="phone">رقم الهاتف</label>
								<p className="order-desc">{data.phone}</p>
								{/* <input type="text" id="phone" defaultValue={data.phone} /> */}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="email">البريد الالكتروني</label>
								<p className="order-desc">{data.email}</p>
								{/* <input type="email" id="email" defaultValue={data.email} /> */}
							</div>
						</div>
					</div>
					<div className="form-item">
						<label htmlFor="notes">ملاحظات</label>
						<p className="order-desc">{data.notes}</p>
						{/* <textarea id="notes" defaultValue={data.notes}></textarea> */}
					</div>
				</div>
			</div>
		</section>
	);
};

export default ServiceShowApplication;
